/*eslint-disable */
const $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import countries from '../../services/country.json';
import {
  mapGetters
} from 'vuex';
export default {
  name: 'organization-user-update',
  components: {},
  props: [],
  data() {
    return {
      submitted: false,
      first_name: '',
      last_name: '',
      email: '',
      division: '',
      activeStatus: Boolean,
      orgUserInfo: {},
      area_of_work:'',
      department:'',
      designation:'',
      countryList: [],
      country:'',
      city:''
    }
  },
  computed: {
    ...mapGetters([
      'orgUserDetailsByIdGetters'
    ]),
    getUserInfoByIdFun() {
      this.orgUserInfo = this.$store.getters.orgUserDetailsByIdGetters.data
      return
    },
    SetIntialStatus() {
      if (this.orgUserInfo != undefined) {
        this.first_name = this.orgUserInfo.first_name
        this.last_name = this.orgUserInfo.last_name
        this.email = this.orgUserInfo.email
        this.area_of_work = this.orgUserInfo.profile.area_of_work
        this.department = this.orgUserInfo.profile.department
        this.designation = this.orgUserInfo.profile.designation
        this.division = this.orgUserInfo.profile.division
        this.country = this.orgUserInfo.profile.country
        this.city = this.orgUserInfo.profile.city
        this.activeStatus = this.orgUserInfo.is_active
      }
    }
  },
    mounted() {
      Object.keys(countries).map((key, index) => {
        this.countryList.push({
          name: countries[key].toLowerCase(),
          value: key.toLowerCase()
        })
      });
      this.getUserInfoByIdFun
      this.SetIntialStatus
    },
    methods: {
      validateBeforeSubmit(e) {
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            let data = {
              email: this.email,
              first_name: this.first_name,
              last_name: this.last_name,
              profile: {
                area_of_work: this.area_of_work,
                department: this.department,
                designation: this.designation,
                country: this.country,
                city: this.city,
                division: this.division
              },
              is_active:this.activeStatus
            }
            this.$store.dispatch('updateOrgUseDetailsByIdFun', {
              data: {
                data: data,
                id: this.$route.params.userId
              }
            })
              .then((res) => {
                  toast.success(res.data.msg);
                  this.$router.push({ name: 'organizationDetails', params: { orgId: res.data.data.profile.organization.id } })
              }).catch((err) => {
                toast.error(err.data.data.email);
              })
            return;
          }
        });
      }
    },
    watch: {
      getUserInfoByIdFun() {
        return this.$store.getters.orgUserDetailsByIdGetters.data
      },
      SetIntialStatus() {
        if (this.orgUserInfo != undefined) {
          this.first_name = this.orgUserInfo.first_name
          this.last_name = this.orgUserInfo.last_name
          this.email = this.orgUserInfo.email
          this.area_of_work = this.orgUserInfo.profile.area_of_work
          this.department = this.orgUserInfo.profile.department
          this.designation = this.orgUserInfo.profile.designation
          this.country = this.orgUserInfo.profile.country
          this.city = this.orgUserInfo.profile.city
          this.division = this.orgUserInfo.profile.division
          this.activeStatus = this.orgUserInfo.is_active
        }
      }
    }
}